module.exports = __webpack_public_path__ + "img/image.477d6270.jpg";